<template>
  <v-container>
    <v-layout row class="mb-3">
      <div>
        <h1 class="mb-4 header display-1">{{msg}}</h1>
        <p>
          This application manages all the display cases and its content available through LA Metro Rail system, Orange and Silver Lines.<br>
        </p>
      </div>
    </v-layout>
    <v-layout row wrap class="mb-4">
      <v-flex xs10>
         <h3 class="title">To get started please select one of the options below or a Metro Location</h3>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-bind="binding">
      <v-flex xs3 sm3 id="cards" v-for="(item, index) in menuItems1" :key="index" class="ma-2 pa-0">
         <v-card  class="pa-0">
            <v-layout>
              <v-flex xs12 class="ma-0 pa-0">
                <v-list three-line class="pa-0">
                  <v-list-tile :to="item.href" class="pt-0">
                    <v-list-tile-avatar>
                      <v-icon large class="pt-3">{{item.icon}}</v-icon>
                    </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>{{item.title}}</v-list-tile-title>
                        <v-list-tile-sub-title>{{item.description}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-3 mb-3">
      <v-flex>
       <h3 class="title">Metro Locations</h3>
       <span class="subheding">See all available content by location</span>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-bind="binding">
      <v-flex xs3 sm3 v-for="(item, index) in menuItems2" :key="index" class="ma-2 pa-0">
         <v-card class="pa-0">
            <v-layout>
              <v-flex xs12 class="ma-0 pa-0">
                <v-list class="pa-0">
                  <v-list-tile :to="item.href" class="pa-0">
                    <v-list-tile-avatar>
                      <v-icon large class="pt-0" :color="item.color">{{item.icon}}</v-icon>
                    </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>{{item.title}}</v-list-tile-title>
                      </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card>
      </v-flex>
    </v-layout>
 </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'Home',
  props: {
    msgs: {type: String}
  },
  data () {
    return {
      msg: 'Display Case Manager'
    }
  },
  computed: {
    ...mapGetters({currentUser: 'currentUser'}),
    binding () {
      const binding = {}
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true
      return binding
    },
    menuItems1: () => {
      let items = [
        {title: 'Search', icon: 'search', href: '/search', color: 'black', description: 'Search all app content'},
        {title: 'Export', icon: 'fas fa-file', href: '/report', color: 'black', description: 'Export app content by line'},
        {title: 'History', icon: 'history', href: '/history', color: 'black', description: 'App log history'},
        {title: 'Tasks', icon: 'fas fa-tasks', href: '/tasks', color: 'black', description: 'All Tasks Available'},
        {title: 'Create Tasks', icon: 'fas fa-list-ol', href: '/installation', color: 'black', description: 'Create new Installation Orders'},
        {title: 'Installer Tasks', icon: 'fas fa-list-ol', href: '/installertasks', color: 'black', description: 'Installers current tasks'}
      ]
      return items
    },
    menuItems2: () => {
      let items = [
        {title: 'Metro Blue Line', icon: 'directions_railway', href: '/rail/801', color: 'indigo'},
        {title: 'Metro Red Line', icon: 'directions_railway', href: '/rail/802', color: 'red'},
        {title: 'Metro Green Line', icon: 'directions_railway', href: '/rail/803', color: 'green'},
        {title: 'Metro Gold Line', icon: 'directions_railway', href: '/rail/804', color: 'amber'},
        {title: 'Metro Purple Line', icon: 'directions_railway', href: '/rail/805', color: 'purple'},
        {title: 'Metro Expo Line', icon: 'directions_railway', href: '/rail/806', color: 'light-blue'},
        {title: 'Metro Orange Line', icon: 'directions_bus', href: '/rail/901', color: 'orange'},
        {title: 'Metro Silver Line 910', icon: 'directions_bus', href: '/rail/910', color: 'grey'},
        {title: 'Metro Silver Line 950', icon: 'directions_bus', href: '/rail/950', color: 'grey'}
      ]
      return items
    }
  },
  created () {
    this.checkToken()
  },
  methods: {
    checkToken () {
      if (window.localStorage.length === 0) {
        this.$router.push('/')
      } else {
        let current = new Date()
        let tokenDate = new Date(this.currentUser.exp * 1000)
        if (!(current.getTime() < tokenDate.getTime())) {
          this.$store.dispatch('logout')
        } else {
          return false
        }
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media only screen and (max-width: 600px) {
   #pic {
    height:50px;
    width:140px;
  }
  .customs-cards {
    height: 361px;
  }
  .header {
    font-size: 8pt;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue